<template>
  <section class="automation" id="automation-section">
    <div v-if="visible" class="content">
      <p :class="{ 'font-weight-bold': lang === 'ru' }" v-text="translations[lang].title" class="title" />

      <div class="automation__wrapper">
        <div v-for="(item, index) in translations[lang].items" :key="index" class="automation__item">
          <div class="automation__icon">
            <img :alt="item.title" :src="require(`@/assets/img/${item.icon}`)" />
          </div>

          <p v-html="item.title" class="automation__title" />

          <p v-html="item.description" class="automation__description" />

          <div v-if="index !== translations[lang].items.length - 1" class="automation__arrow">
            <img src="@/assets/img/next-icon.svg" alt="next-icon" />
          </div>
        </div>
      </div>

      <div class="trust__button" v-if="!hideActionBtn">
        <button v-text="translations[lang].button" class="custom-button" @click="openQuestionForm" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Automation',
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    openQuestionForm: {
      default: () => null,
      type: Function,
    },
    visible: {
      default: false,
      type: Boolean,
    },
    hideActionBtn: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    translations: {
      en: {
        button: 'Ask more',
        items: [
          {
            icon: 'step-1.svg',
            description: 'Upload a layout in <br/><span>1</span> minute',
            title: 'Download a floorpan',
          },
          {
            icon: 'step-2.svg',
            description: 'AI creates <span>2D</span>, <span>3D</span> <br/>and <span>360° tour</span>',
            title: 'Do nothing',
          },
          {
            icon: 'step-3.svg',
            description: 'Visuals can be optionally <br/><span>checked by human</span>',
            title: 'Take a rest',
          },
          {
            icon: 'step-4.png',
            description: 'You get a <span>full bundle</span> <br/>of visuals',
            title: 'Get visuals',
          },
        ],
        title: 'How AI Getfloorplan works',
      },
      ru: {
        button: 'Спросить',
        items: [
          {
            icon: 'step-1.svg',
            description: 'Оформляете заказ за <br/>1 минуту',
            title: 'Загружаете',
          },
          {
            icon: 'step-2.svg',
            description: 'ИИ создаёт 2D, 3D <br/>и 360 тур',
            title: 'Ничего <br/>не делаете',
          },
          {
            icon: 'step-3.svg',
            description: 'Визуализации <br/>по желанию может <br/>проверить специалист',
            title: 'Отдыхаете',
          },
          {
            icon: 'step-4.png',
            description: 'Вы получаете полный <br/>пакет материалов',
            title: 'Получаете <br/>материалы',
          },
        ],
        title: 'Как ИИ Hart Estate работает?',
      },
    },
  }),
};
</script>
